import { Button, Flex, ModalFooter, useBreakpointValue } from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'

import { PropsWithChildrenOptional } from 'constants/typings'

interface SubmitModalFooterProps {
  cancelButtonText?: string
  submitButtonText: string
  isSubmitDisabled?: boolean
  isSubmitLoading?: boolean
  isFixedToBottom?: boolean
  onCancel: () => void
  onSubmit: () => void
}

export const SubmitModalFooter = ({
  cancelButtonText,
  submitButtonText,
  isSubmitDisabled,
  isSubmitLoading,
  children,
  onCancel,
  onSubmit,
  isFixedToBottom,
}: PropsWithChildrenOptional<SubmitModalFooterProps>) => {
  const { t } = useTranslation('common')
  const isMobile = useBreakpointValue({
    base: true,
    xs: true,
    sm: true,
    md: false,
  })

  return (
    <ModalFooter flexDirection={{ base: 'column', sm: 'row' }}>
      <Flex
        mb={{ base: '10px', sm: 0 }}
        flexDirection={{ base: 'column', sm: 'row' }}
        width={{ base: '100%', sm: 'initial' }}
        {...(isFixedToBottom &&
          isMobile && {
            position: 'fixed',
            bottom: '0px',
            backgroundColor: 'brand.white',
            width: '100%',
            left: 0,
            right: 0,
            padding: '10px',
            margin: 0,
          })}
        sx={{
          '> :not(:last-child)': {
            mb: { base: '10px', sm: 0 },
            width: { base: '100%', sm: 'initial' },
          },
        }}
      >
        <Button variant="secondary" mr={3} onClick={onCancel}>
          {cancelButtonText ? cancelButtonText : t('CANCEL')}
        </Button>
        <Button
          onClick={onSubmit}
          isDisabled={isSubmitDisabled}
          isLoading={isSubmitLoading}
          type="submit"
        >
          {submitButtonText}
        </Button>
      </Flex>

      {children}
    </ModalFooter>
  )
}
